<h2><span>{{ title() }}</span>
  @if (hideable()) {
    <svg
      (click)="toggle()"
      width="20"
      height="20"
      class="shrink-0 block"
      viewBox="0 0 16 16">
      <use class="fill-current" [attr.xlink:href]="SvgSpriteIcon.Close16"></use>
    </svg>
  }
</h2>
<ng-content/>
